import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import type { PaymentTypes } from '@/types/PaymentTypes';
import {
  australiaPaymentTypes,
  belgiumPaymentTypes,
  caPaymentTypes,
  germanyPaymentTypes,
  frenchPaymentTypes,
  iePaymentTypes,
  japanPaymentTypes,
  luxembourgPaymentTypes,
  newZealandPaymentTypes,
  ukPaymentTypes,
  usPaymentTypes,
  usWithMoheganPaymentTypes,
  usWithPuertoRicoCreditPaymentTypes
} from '../../../helpers/paymentTypes';

import { getEnvironment } from '@/components/@lushdigital/helper-functions';

function usePaymentTypes(countryCode, shopId): PaymentTypes {
  const [types, setTypes] = useState({});

  useEffect(() => {
    switch (countryCode) {
      case 'JP':
        setTypes(japanPaymentTypes);
        break;
      case 'DE':
        setTypes(germanyPaymentTypes);
        break;
      case 'FR':
        setTypes(frenchPaymentTypes);
        break;
      case 'LU':
        setTypes(luxembourgPaymentTypes);
        break;
      case 'BE':
        setTypes(belgiumPaymentTypes);
        break;
      case 'IE':
        setTypes(iePaymentTypes);
        break;
      case 'CA':
        setTypes(caPaymentTypes);
        break;
      case 'US':
        if (getEnvironment() === 'production') {
          if (shopId === 1387) {
            setTypes(usWithMoheganPaymentTypes);
          } else if (shopId === 1572) {
            setTypes(usWithPuertoRicoCreditPaymentTypes);
          } else {
            setTypes(usPaymentTypes);
          }
        } else {
          if (shopId === 3255) {
            setTypes(usWithMoheganPaymentTypes);
            break;
          }
          if (shopId === 3297) {
            setTypes(usWithPuertoRicoCreditPaymentTypes);
            break;
          }
          setTypes(usPaymentTypes);
          break;
        }
        break;
      case 'AU':
        setTypes(australiaPaymentTypes);
        break;
      case 'NZ':
        setTypes(newZealandPaymentTypes);
        break;
      case 'GB':
      default:
        setTypes(ukPaymentTypes);
        break;
    }
  }, [countryCode, shopId]);

  return types;
}

usePaymentTypes.propTypes = { countryCode: PropTypes.string };

export default usePaymentTypes;
